function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function looksLikeHtml(value: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

/** Convert stored plain text into HTML for the rich editor. */
export function prepareBodyForEditor(raw: string | null | undefined): string {
  const trimmed = (raw ?? "").trim();
  if (!trimmed) return "";

  if (looksLikeHtml(trimmed)) {
    return trimmed;
  }

  const normalized = trimmed.replace(/\r\n/g, "\n");

  if (normalized.includes("\n\n")) {
    return normalized
      .split(/\n\s*\n/)
      .filter((block) => block.length > 0)
      .map(
        (block) =>
          `<p>${escapeHtml(block).replace(/\n/g, "<br />")}</p>`,
      )
      .join("");
  }

  if (normalized.includes("\n")) {
    return normalized
      .split(/\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => `<p>${escapeHtml(line)}</p>`)
      .join("");
  }

  return `<p>${escapeHtml(normalized)}</p>`;
}

/** Normalize template body for read-only HTML preview. */
export function prepareBodyForPreview(raw: string | null | undefined): string {
  const trimmed = (raw ?? "").trim();
  if (!trimmed) return "";

  if (looksLikeHtml(trimmed)) {
    return trimmed;
  }

  return escapeHtml(trimmed.replace(/\r\n/g, "\n")).replace(/\n/g, "<br />");
}
